import Store from "../store";
import { axiosInstance } from "@/main.js";
import moment from "moment";

export default function onBeforeEnter(step) {
  return async (to, from, next) => {
    if (
      from.query.hasOwnProperty("c") &&
      from.query.hasOwnProperty("clinica")
    ) {
      let clinic = { stepId: 3, id: from.query.clinica };
      Store.dispatch("load_selected", clinic);

      Store.dispatch("set_clinicspecific", true);
    }

    if (Store.getters.first_render && from.name !== "index") {
      await mountState(to, () => {
        Store.dispatch(
          "set_type",
          to.fullPath.includes("consulta")
            ? "consulta"
            : to.fullPath.includes("exame")
            ? "exame"
            : "retorno"
        );
        Store.dispatch("set_params", {
          organizationId: to.params.organizationId
        });
        Store.dispatch("set_query").then(() => {
          Store.dispatch("set_firstrender", false);
          next(Store.getters.router_go);
        });
      });
    } else {
      Store.dispatch("set_firstrender", false);
      Store.commit("set_actualstep", step);
      next();
    }
  };
}

export function generateTo(step, route) {
  let name = `${
    route.fullPath.includes("exame")
      ? "exame"
      : route.fullPath.includes("consulta")
      ? "consulta"
      : "retorno"
  }_`;

  switch (step) {
    case 1:
      name += "convenio";
      break;
    case 2:
      name += route.fullPath.includes("exame")
        ? "procedimento"
        : "especialidade";
      break;
    case 3:
      name += "clinica";
      break;
    case 4:
      name += "agendar";
      break;
    case 5:
      name += "profissional";
      break;
    case 6:
      name += "paciente";
      break;
    case 7:
      name += "confirmacao";
      break;
    case 8:
      name = "finish";
      break;
  }

  return name;
}

async function mountState(route, callback) {
  let query = {};

  if (!route.query) {
    route.query = query;
  }

  if (route.query.clinica) {
    query = { ...query, clinica_id: route.query.clinica };
  }

  if (route.query.convenio) {
    query = { ...query, convenio_id: route.query.convenio };
  }

  if (route.query.especialidade) {
    query = { ...query, especialidade_id: route.query.especialidade };
  }

  if (route.query.horario) {
    query = { ...query, horario_id: route.query.horario };
  }

  if (route.query.procedimento) {
    query = { ...query, procedimento_id: route.query.procedimento };
  }

  if (route.query.medico) {
    query = { ...query, profissional_id: route.query.medico };
  }

  if (Object.keys(query).length !== 0) {
    let response = await axiosInstance.get("agendamentos/state", {
      params: { ...query },
      headers: { "X-Organizacao-ID": route.params.organizationId }
    });

    mountSelected(response.data);
  } else {
    Store.commit("clear_selected");

    Store.commit("set_actualstep", 0);
  }

  callback();
}

function mountSelected(data) {
  Store.commit("clear_selected");

  if (data.clinica) {
    Store.dispatch("load_selected", {
      ...data.clinica,
      stepId: 3
    });
  }

  if (data.convenio) {
    Store.dispatch("load_selected", {
      ...data.convenio,
      stepId: 1
    });
  } else {
    Store.commit("set_actualstep", 0);
    return;
  }

  if (data.especialidade) {
    Store.dispatch("load_selected", {
      ...data.especialidade,
      stepId: 2
    });
  } else if (data.procedimento) {
    Store.dispatch("load_selected", {
      ...data.procedimento,
      stepId: 2
    });
  } else {
    Store.commit("set_actualstep", 1);
    return;
  }

  if (!data.clinica) {
    Store.commit("set_actualstep", 2);
    return;
  }

  if (data.horario) {
    Store.dispatch("load_selected", {
      ...data.horario,
      medics: data.horario.agendas,
      nome: `${moment(data.horario.hora).format("DD/MM")} às ${moment(
        data.horario.hora
      ).format("LT")}`,
      stepId: 4
    });
  } else {
    Store.commit("set_actualstep", 3);
    return;
  }

  if (data.profissional) {
    Store.dispatch("load_selected", {
      ...data.profissional,
      stepId: 5
    });
  } else {
    Store.commit("set_actualstep", 4);
    return;
  }

  Store.commit("set_actualstep", 5);
}
